
import DivSpan from '@/components/DivSpan';
import searchMultiplyDate from '@/components/search-multiply-date';
import manualSearch from '@/components/manual-search';
import dateFormat from 'vux/src/tools/date/format.js'



export default {
name: "srm-mobile-header",
/**
* title  顶部标题
* tabList tab列表
* inputCondition  input输入框的配置
* selectConfig  点击选择的配置
* **/
props: ['config', 'fixRules'],
components: {DivSpan, searchMultiplyDate,manualSearch},
data() {
return {
value: '',
list: [],
searchData: {},
isReload: true,
tabIndex: 1,
searchIndex: 1,//选择框  对应index
clickIndex: 1,
number: 0,
isMontend: false,
pageRules: {
direction: "DESC",
fromClientType: "pc",
number: 0,
property: "createdDate",
size: 10,
rules: [],
specialConditions: [],
workflowSearchBean: {}
},
url: '',
selectedConfigText: [
{text: '', code: ''},
{text: '', code: ''},
{text: '', code: ''}
],
specialConditions: [],
defaultRules:[],
isFirst:false,
isManualChecked:false,
manualCheckList:[],
finallymanualCheckList:[],
}
},
methods: {
reload() {
this.isReload = false;
this.$nextTick(() => {
this.isReload = true;
})
},
searchDate(e) {
if (e.dateGe) {
this.selectedConfigText[this.clickIndex].text = 'DATE'
if(this.config.selectConfig[this.clickIndex].isOld){
this.selectedConfigText[this.clickIndex].code=[dateFormat( new Date(e.dateGe).getTime()-8*60*60*1000,"YYYY-MM-DD HH:mm:ss"),dateFormat(new Date(e.dateLe).getTime()+16*60*60*1000-1,"YYYY-MM-DD HH:mm:ss")]
}else {
this.selectedConfigText[this.clickIndex].code = [new Date(new Date(e.dateGe).getTime()), new Date(new Date(e.dateLe).getTime() + (24) * 60 * 60 * 1000 - 1)];

}
}
this.getFinallyManulaList()
this.getlist()


},
getManualRules(e){



if(e){
this.manualCheckList=[];
e.forEach(e=>{
if(e.ch=="date"){
this.manualCheckList.push({field:e.name,values:e.code,option:e.option})
}else {
this.manualCheckList.push({field:e.name,values:[e.code],option:e.option})
}
})

}else {
this.manualCheckList=[];
}
if(this.isManualChecked){
let list=[];
this.selectedConfigText.forEach((item, i) => {
switch (item.text) {
case 'DATE':
this.config.selectConfig[i].rules[0].values = item.code;
list = [].concat(list, this.config.selectConfig[i].rules);
break;
default:
if (item.code) {
this.config.selectConfig[i].rules[0].values = [item.code];
list= [].concat(list, this.config.selectConfig[i].rules);
}
}
})

if(this.manualCheckList.length){
this.finallymanualCheckList=this.distinct([...this.manualCheckList,...list],'field')
console.log(this.finallymanualCheckList)
}else {
this.finallymanualCheckList=[...list];
}

}
this.getlist();
},
getFinallyManulaList(){

if(this.isManualChecked){
let list=[];
this.selectedConfigText.forEach((item, i) => {
switch (item.text) {
case 'DATE':
this.config.selectConfig[i].rules[0].values = item.code;
list = [].concat(list, this.config.selectConfig[i].rules);
break;
default:
if (item.code) {
this.config.selectConfig[i].rules[0].values = [item.code];
list= [].concat(list, this.config.selectConfig[i].rules);
}
}
})



if(this.manualCheckList.length){
this.finallymanualCheckList=this.distinct([...list,...this.manualCheckList],'field')
}else {
this.finallymanualCheckList=[...list];
}

}
},
distinct(array, key) {
array = JSON.parse(JSON.stringify(array));

array = array.filter(val => val)
let result = []
let obj = {}
if (array.length) {
for (let i of array) {
let attr = i[key];
if (!obj[attr]) {
result.push(i)
obj[attr] = 1
}
}
return result
}


},

delDate() {
this.selectedConfigText[this.clickIndex].text = null;
this.selectedConfigText[this.clickIndex].code = null;
this.getlist()
},
contractTypeChange(e) {
if (e == -1) {
this.selectedConfigText[this.clickIndex].text = null;
this.selectedConfigText[this.clickIndex].code = null;
} else {
this.selectedConfigText[this.clickIndex].text = e.name;
this.selectedConfigText[this.clickIndex].code = e.code;
this.getFinallyManulaList()
}
this.getlist()
},
search(e) {
if (e) {
this.selectedConfigText[this.clickIndex].text = e[this.config.selectConfig[this.clickIndex].searchCondition.label];
this.selectedConfigText[this.clickIndex].code = e[this.config.selectConfig[this.clickIndex].searchCondition.code];
}
this.getFinallyManulaList()
this.getlist()

},
del() {
this.selectedConfigText[this.clickIndex].text = null;
this.selectedConfigText[this.clickIndex].code = null;
this.getlist()
},
getClickIndex(index) {
this.clickIndex = index
},
statusClick(e) {
this.tabIndex = e;
this.$emit('tab-index', e);
this.selectedConfigText = [
{text: '', code: ''},
{text: '', code: ''},
{text: '', code: ''}
];
this.manualCheckList=[];
this.finallymanualCheckList=[];
this.reload();
setTimeout(() => {
this.addFixRules();
this.getlist();
});
},

clear() {
this.value = null;
this.getlist()
},
searchList() {
this.getlist()
},
getMore() {
this.number++;
this.pageRules.number = this.number;
this.getPageRules();
this.$post(this.config.url, this.pageRules).then((list) => {
if (list.content) {
this.list = list.content;
}else{
this.list = [];
}
this.$emit('get-list', this.list,'bottom',true);
this.getInitPageRules();
if (list.content.length < 10) {
this.$vux.toast.text("已经加载全部")
}
}).catch((error) => {
this.$loadingHide();
this.$emit('get-list', [],'bottom',true);
});
},
getlist(topLoad) {
this.number = 0;
this.pageRules.number = this.number;
this.$loadingShow();
this.$nextTick(() => {
this.getPageRules();
this.url = this.config.url;
this.$post(this.url, this.pageRules).then((list) => {
if (list.content) {
this.list = list.content;
} else {
this.list = [];
}
if(topLoad){
this.$emit('get-list', this.list,'top');
}else{
this.$emit('get-list', this.list);
}
this.getInitPageRules();
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
if(topLoad){
this.$emit('get-list', [],'top');
}else{
this.$emit('get-list', []);
}
});
})

},
getPageRules() {
if(this.defaultRules.length && !this.isFirst){
this.pageRules.rules=[].concat(this.pageRules.rules,this.defaultRules)
this.isFirst=true;
}
if (this.config.property) {
this.pageRules.property = this.config.property
}
if(this.config.specialCondition){
for(let attr in this.config.specialCondition){
this.pageRules[attr] = this.config.specialCondition[attr]
}
}
if (this.config.workflowSearchBean) {
this.pageRules.workflowSearchBean = this.config.workflowSearchBean;
} else {
delete this.pageRules.workflowSearchBean;
}
if (this.value) {
let configRules = this.config.inputCondition.rules;
if (configRules.length > 0) {
configRules[0].values = [this.value]
}
this.pageRules.rules = [].concat(this.pageRules.rules,configRules);
}
if (this.specialConditions && this.specialConditions.length) {
this.pageRules.specialConditions = this.specialConditions;
}
if(this.isManualChecked){
this.pageRules.rules = [].concat(this.pageRules.rules, this.finallymanualCheckList);

}else {
this.selectedConfigText.forEach((item, i) => {
switch (item.text) {
case 'DATE':
this.config.selectConfig[i].rules[0].values = item.code;
this.pageRules.rules = [].concat(this.pageRules.rules, this.config.selectConfig[i].rules);
break;
default:
if (item.code) {
this.config.selectConfig[i].rules[0].values = [item.code];
this.pageRules.rules = [].concat(this.pageRules.rules, this.config.selectConfig[i].rules);
}
}
})
}

},
getInitPageRules() {
this.pageRules.rules = [];
this.pageRules.specialConditions = [];
this.specialConditions = [];
this.pageRules.property = 'createdDate';
this.pageRules.workflowSearchBean = {};
this.addFixRules();
},
addFixRules() {

this.pageRules.rules = [];
this.defaultRules = [];
if (this.config.fixRules && this.config.fixRules.rules && this.config.fixRules.rules.length) {
if(this.config.fixRules.fixed){
this.pageRules.rules = this.config.fixRules.rules;
}else{
this.defaultRules=this.config.fixRules.rules;
}
}
},
},
mounted() {
this.isMontend = true;

},
watch: {
config() {
this.addFixRules();
}
},
created() {
if(this.config.selectConfig && this.config.selectConfig.filter(val=>val.type=='more').length){
this.isManualChecked=true;
}
}
}



// WEBPACK FOOTER //
// ./src/components/srm-mobile-header.vue